export default "__VITE_ASSET__DDY0Gi7R__";